interface SearchResultSummaryProps {
  keyword?: string;
  resultCount: number;
  className?: string;
}

function SearchResultSummary({ keyword, resultCount, className = '' }: SearchResultSummaryProps) {
  if (!keyword) {
    return null;
  }

  return (
    <span className={`text-sm ${className}`}>
      {`「${keyword}」で絞り込んだ結果：${resultCount}件`}
    </span>
  );
}

export default SearchResultSummary;
